import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReportTable from "../../../components/report/report-table";
import ScoreView from "../../../components/UI/ScoreView";
import { StudentReportSubTopicWiseService } from "../../../services/reports";
import * as configActions from "../../../store/config/actions";
import { useDispatch } from "react-redux";
import Notation from "../../../components/report/notation";
import { handleCompPerformance } from "../../../helpers";
import { textIdentifier } from "../../../textIdentifier";

export default function SubTopicClassReport() {
  const {
    selectedCompetition,
    selectedSchool,
    selectedClass,
    selectedStudent,
    lang
  } = useSelector((state) => state.main);
  const navigate = useNavigate();
  const [values, setValues] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      const res = await StudentReportSubTopicWiseService(
        selectedCompetition.id,
        selectedClass.code,
        selectedStudent.id
      );
      //  filtering data
      const vals = res.data.map((item) => {
        const { accuracy, proficiency, marks } = item;

        // selected school
        const _competition = selectedCompetition.subTopicsWiseReportData.find(
          (data) => data.id === item.id
        );

        // selected school
        const _school = selectedSchool.subTopicData.find(
          (data) => data.id === item.id
        );

        // class
        const _class = selectedClass.subTopicData.find(
          (data) => data.id === item.id
        );

        let school_proficiency_status = handleCompPerformance(
          proficiency,
          _competition.proficiency
        );
        let class_proficiency_status = handleCompPerformance(
          proficiency,
          _school.proficiency
        );
        let student_proficiency_status = handleCompPerformance(
          proficiency,
          _class.proficiency
        );

        let school_accuracy_status = handleCompPerformance(
          accuracy,
          _competition.accuracy
        );
        let class_accuracy_status = handleCompPerformance(
          accuracy,
          _school.accuracy
        );
        let student_accuracy_status = handleCompPerformance(
          accuracy,
          _class.accuracy
        );

        let school_marks_status = handleCompPerformance(
          marks,
          _competition.marks
        );
        let class_marks_status = handleCompPerformance(marks, _school.marks);
        let student_marks_status = handleCompPerformance(marks, _class.marks);

        const val = Object.assign(item, {
          school_proficiency_status,
          class_proficiency_status,
          student_proficiency_status,
          school_accuracy_status,
          class_accuracy_status,
          student_accuracy_status,
          school_marks_status,
          class_marks_status,
          student_marks_status,

          overall_competition_proficiency: _competition.proficiency,
          overall_competition_accuracy: _competition.accuracy,
          overall_competition_marks: _competition.marks,

          overall_school_proficiency: _school.proficiency,
          overall_school_accuracy: _school.accuracy,
          overall_school_marks: _school.marks,

          overall_class_proficiency: _class.proficiency,
          overall_class_accuracy: _class.accuracy,
          overall_class_marks: _class.marks,
        });

        return val;
      });

      setValues(vals);
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
    } finally {
      setIsFetching(false);
    }
  };

  const handleFloatParse = (val) => {
    // return parseFloat(val).toFixed(2);
    return val;
  };

  const competition_proficiency_status = (value, comp_proficiency) => (
    <ScoreView
      content={`${textIdentifier["overall-proficiency"][lang]} ${parseFloat(comp_proficiency).toFixed(
        2
      )}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const school_proficiency_status = (value, school_proficiency) => (
    <ScoreView
      content={`${textIdentifier["school-proficiency"][lang]} ${parseFloat(school_proficiency).toFixed(
        2
      )}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const class_proficiency_status = (value, class_proficiency) => (
    <ScoreView
      content={`${textIdentifier["class-proficiency"][lang]} ${parseFloat(class_proficiency).toFixed(2)}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const competition_accuracy_status = (value, comp_accuracy) => (
    <ScoreView
      content={`${textIdentifier["overall-accuracy"][lang]} ${parseFloat(comp_accuracy).toFixed(2)}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const school_accuracy_status = (value, school_accuracy) => (
    <ScoreView
      content={`${textIdentifier["school-accuracy"][lang]} ${parseFloat(school_accuracy).toFixed(2)}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const class_accuracy_status = (value, class_accuracy) => (
    <ScoreView
      content={`${textIdentifier["class-accuracy"][lang]} ${parseFloat(class_accuracy).toFixed(2)}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const competition_marks_status = (value, comp_marks) => (
    <ScoreView content={`${textIdentifier["overall-marks"][lang]} ${parseFloat(comp_marks).toFixed(2)}`}>
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const school_marks_status = (value, school_marks) => (
    <ScoreView content={`${textIdentifier["school-marks"][lang]} ${parseFloat(school_marks).toFixed(2)}`}>
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const class_marks_status = (value, class_marks) => (
    <ScoreView content={`${textIdentifier["class-marks"][lang]} ${parseFloat(class_marks).toFixed(2)}`}>
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  useEffect(() => {
    if (
      !selectedCompetition ||
      !selectedSchool ||
      !selectedClass ||
      !selectedStudent
    ) {
      navigate("/");
    } else {
      fetchData();
    }
  }, []);

  if (values.length === 0 && !isFetching) {
    return <p>{textIdentifier["no-data-found"][lang]}</p>;
  }

  return (
    <div className="cr-card sub-topic-wise-report">
      {values.map((_, i) => (
        <div key={i} className="col">
          <h4>
            {i + 1}. {_.name}
          </h4>
          <ReportTable
            data={[
              [
                `${_.proficiency}%`,
                `${_.accuracy}%`,
                parseFloat(
                  _.easy_question_count +
                    _.medium_question_count +
                    _.hard_question_count
                ).toFixed(2),
                _.marks,
              ],
              [
                <div className="flex-center">
                  {competition_proficiency_status(
                    _.school_proficiency_status,
                    _.overall_competition_proficiency
                  )}
                  {school_proficiency_status(
                    _.class_proficiency_status,
                    _.overall_school_proficiency
                  )}
                  {class_proficiency_status(
                    _.student_proficiency_status,
                    _.overall_class_proficiency
                  )}
                </div>,
                <div className="flex-center">
                  {competition_accuracy_status(
                    _.school_accuracy_status,
                    _.overall_competition_accuracy
                  )}
                  {school_accuracy_status(
                    _.class_accuracy_status,
                    _.overall_school_accuracy
                  )}
                  {class_accuracy_status(
                    _.student_accuracy_status,
                    _.overall_class_accuracy
                  )}
                </div>,
                `(E${_.easy_question_count}, M${_.medium_question_count}, H${_.hard_question_count})`,
                <div className="flex-center">
                  {competition_marks_status(
                    _.school_proficiency_status,
                    _.overall_competition_marks
                  )}
                  {school_marks_status(
                    _.class_proficiency_status,
                    _.overall_school_marks
                  )}
                  {class_marks_status(
                    _.student_proficiency_status,
                    _.overall_class_marks
                  )}
                </div>,
              ],
            ]}
            headers={[[textIdentifier["proficiency"][lang], textIdentifier["accuracy"][lang], textIdentifier["question-count"][lang], textIdentifier["marks"][lang]]]}
          />
        </div>
      ))}
    </div>
  );
}
